import {
  uuid,
} from 'utils/misc';
import {
  create,
} from 'zustand';

type Props = {
  principalFacilityState: string | null;
  clientId: string;
  actions: {
    setPrincipalFacilityState: (state: string | null) => void;
  };
};

const useUserStore = create<Props>(
  (set) => ({
    principalFacilityState: null,
    clientId: uuid(),
    actions: {
      setPrincipalFacilityState: (state: string | null) => set({
        principalFacilityState: state,
      }),
    },
  }),
);

export const usePrincipalFacilityState = () => useUserStore(
  (state: Props) => state.principalFacilityState,
);

export const useClientId = () => useUserStore(
  (state: Props) => state.clientId,
);

export const useUserActions = () => useUserStore(
  (state: Props) => state.actions,
);
